window.lib = window.lib || {};
window.images = window.images || {};
window.ss = window.ss || {};
(function (lib, img, ss, cjs) {

var p; // shortcut to reference prototypes

lib.ssMetadata = [];


(lib.AnMovieClip = function(){
	this.actionFrames = [];
	this.ignorePause = false;
	this.gotoAndPlay = function(positionOrLabel){
		cjs.MovieClip.prototype.gotoAndPlay.call(this,positionOrLabel);
	}
	this.play = function(){
		cjs.MovieClip.prototype.play.call(this);
	}
	this.gotoAndStop = function(positionOrLabel){
		cjs.MovieClip.prototype.gotoAndStop.call(this,positionOrLabel);
	}
	this.stop = function(){
		cjs.MovieClip.prototype.stop.call(this);
	}
}).prototype = p = new cjs.MovieClip();
// symbols:



(lib.BlueOrange_01 = function() {
	this.initialize(img.LevelAssets_BlueOrange_01);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,154,221);


(lib.BlueOrange_02 = function() {
	this.initialize(img.LevelAssets_BlueOrange_02);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,154,221);


(lib.BlueOrange_03 = function() {
	this.initialize(img.LevelAssets_BlueOrange_03);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,154,184);


(lib.BlueOrange_04 = function() {
	this.initialize(img.LevelAssets_BlueOrange_04);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,215,235);


(lib.BlueOrange_05 = function() {
	this.initialize(img.LevelAssets_BlueOrange_05);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,149,221);


(lib.BlueOrange_06 = function() {
	this.initialize(img.LevelAssets_BlueOrange_06);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,149,205);


(lib.BlueOrange_07 = function() {
	this.initialize(img.LevelAssets_BlueOrange_07);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,187,221);


(lib.BlueOrange_08 = function() {
	this.initialize(img.LevelAssets_BlueOrange_08);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,154,184);


(lib.BlueOrange_09 = function() {
	this.initialize(img.LevelAssets_BlueOrange_09);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,150,184);


(lib.BlueOrange_10 = function() {
	this.initialize(img.LevelAssets_BlueOrange_10);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,215,235);


(lib.BlueOrange_11 = function() {
	this.initialize(img.LevelAssets_BlueOrange_11);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,182,184);


(lib.BlueOrange_12 = function() {
	this.initialize(img.LevelAssets_BlueOrange_12);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,248,235);


(lib.BlueOrange_13 = function() {
	this.initialize(img.LevelAssets_BlueOrange_13);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,182,184);


(lib.GreenBlue_01 = function() {
	this.initialize(img.LevelAssets_GreenBlue_01);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,154,221);


(lib.GreenBlue_02 = function() {
	this.initialize(img.LevelAssets_GreenBlue_02);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,154,221);


(lib.GreenBlue_03 = function() {
	this.initialize(img.LevelAssets_GreenBlue_03);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,154,184);


(lib.GreenBlue_04 = function() {
	this.initialize(img.LevelAssets_GreenBlue_04);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,215,235);


(lib.GreenBlue_05 = function() {
	this.initialize(img.LevelAssets_GreenBlue_05);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,149,221);


(lib.GreenBlue_06 = function() {
	this.initialize(img.LevelAssets_GreenBlue_06);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,149,205);


(lib.GreenBlue_07 = function() {
	this.initialize(img.LevelAssets_GreenBlue_07);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,187,221);


(lib.GreenBlue_08 = function() {
	this.initialize(img.LevelAssets_GreenBlue_08);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,154,184);


(lib.GreenBlue_09 = function() {
	this.initialize(img.LevelAssets_GreenBlue_09);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,150,184);


(lib.GreenBlue_10 = function() {
	this.initialize(img.LevelAssets_GreenBlue_10);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,215,235);


(lib.GreenBlue_11 = function() {
	this.initialize(img.LevelAssets_GreenBlue_11);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,182,184);


(lib.GreenBlue_12 = function() {
	this.initialize(img.LevelAssets_GreenBlue_12);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,248,235);


(lib.GreenBlue_13 = function() {
	this.initialize(img.LevelAssets_GreenBlue_13);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,182,184);


(lib.GreenOrange_01 = function() {
	this.initialize(img.LevelAssets_GreenOrange_01);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,154,221);


(lib.GreenOrange_02 = function() {
	this.initialize(img.LevelAssets_GreenOrange_02);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,154,221);


(lib.GreenOrange_03 = function() {
	this.initialize(img.LevelAssets_GreenOrange_03);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,154,184);


(lib.GreenOrange_04 = function() {
	this.initialize(img.LevelAssets_GreenOrange_04);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,215,235);


(lib.GreenOrange_05 = function() {
	this.initialize(img.LevelAssets_GreenOrange_05);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,149,221);


(lib.GreenOrange_06 = function() {
	this.initialize(img.LevelAssets_GreenOrange_06);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,149,205);


(lib.GreenOrange_07 = function() {
	this.initialize(img.LevelAssets_GreenOrange_07);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,187,221);


(lib.GreenOrange_08 = function() {
	this.initialize(img.LevelAssets_GreenOrange_08);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,154,184);


(lib.GreenOrange_09 = function() {
	this.initialize(img.LevelAssets_GreenOrange_09);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,150,184);


(lib.GreenOrange_10 = function() {
	this.initialize(img.LevelAssets_GreenOrange_10);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,215,235);


(lib.GreenOrange_11 = function() {
	this.initialize(img.LevelAssets_GreenOrange_11);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,182,184);


(lib.GreenOrange_12 = function() {
	this.initialize(img.LevelAssets_GreenOrange_12);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,248,235);


(lib.GreenOrange_13 = function() {
	this.initialize(img.LevelAssets_GreenOrange_13);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,182,184);


(lib.Location1Layer1_11 = function() {
	this.initialize(img.LevelAssets_Location1Layer1_11);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1296,3000);


(lib.Location1Layer1_12 = function() {
	this.initialize(img.LevelAssets_Location1Layer1_12);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1298,3000);


(lib.Location1Layer1_13 = function() {
	this.initialize(img.LevelAssets_Location1Layer1_13);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1296,3000);


(lib.Location1Layer1_14 = function() {
	this.initialize(img.LevelAssets_Location1Layer1_14);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1298,3000);


(lib.Location1Layer1_15 = function() {
	this.initialize(img.LevelAssets_Location1Layer1_15);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1297,3000);


(lib.OrangeGreen_01 = function() {
	this.initialize(img.LevelAssets_OrangeGreen_01);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,154,221);


(lib.OrangeGreen_02 = function() {
	this.initialize(img.LevelAssets_OrangeGreen_02);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,153,221);


(lib.OrangeGreen_03 = function() {
	this.initialize(img.LevelAssets_OrangeGreen_03);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,153,184);


(lib.OrangeGreen_04 = function() {
	this.initialize(img.LevelAssets_OrangeGreen_04);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,215,235);


(lib.OrangeGreen_05 = function() {
	this.initialize(img.LevelAssets_OrangeGreen_05);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,149,221);


(lib.OrangeGreen_06 = function() {
	this.initialize(img.LevelAssets_OrangeGreen_06);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,150,205);


(lib.OrangeGreen_07 = function() {
	this.initialize(img.LevelAssets_OrangeGreen_07);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,186,221);


(lib.OrangeGreen_08 = function() {
	this.initialize(img.LevelAssets_OrangeGreen_08);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,154,184);


(lib.OrangeGreen_09 = function() {
	this.initialize(img.LevelAssets_OrangeGreen_09);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,150,184);


(lib.OrangeGreen_10 = function() {
	this.initialize(img.LevelAssets_OrangeGreen_10);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,216,235);


(lib.OrangeGreen_11 = function() {
	this.initialize(img.LevelAssets_OrangeGreen_11);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,183,184);


(lib.OrangeGreen_12 = function() {
	this.initialize(img.LevelAssets_OrangeGreen_12);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,250,235);


(lib.OrangeGreen_13 = function() {
	this.initialize(img.LevelAssets_OrangeGreen_13);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,182,184);


(lib.OrangePurple_01 = function() {
	this.initialize(img.LevelAssets_OrangePurple_01);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,154,220);


(lib.OrangePurple_02 = function() {
	this.initialize(img.LevelAssets_OrangePurple_02);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,153,220);


(lib.OrangePurple_03 = function() {
	this.initialize(img.LevelAssets_OrangePurple_03);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,153,184);


(lib.OrangePurple_04 = function() {
	this.initialize(img.LevelAssets_OrangePurple_04);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,215,234);


(lib.OrangePurple_05 = function() {
	this.initialize(img.LevelAssets_OrangePurple_05);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,149,220);


(lib.OrangePurple_06 = function() {
	this.initialize(img.LevelAssets_OrangePurple_06);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,150,204);


(lib.OrangePurple_07 = function() {
	this.initialize(img.LevelAssets_OrangePurple_07);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,186,220);


(lib.OrangePurple_08 = function() {
	this.initialize(img.LevelAssets_OrangePurple_08);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,154,185);


(lib.OrangePurple_09 = function() {
	this.initialize(img.LevelAssets_OrangePurple_09);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,150,185);


(lib.OrangePurple_10 = function() {
	this.initialize(img.LevelAssets_OrangePurple_10);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,216,234);


(lib.OrangePurple_11 = function() {
	this.initialize(img.LevelAssets_OrangePurple_11);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,183,185);


(lib.OrangePurple_12 = function() {
	this.initialize(img.LevelAssets_OrangePurple_12);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,250,235);


(lib.OrangePurple_13 = function() {
	this.initialize(img.LevelAssets_OrangePurple_13);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,182,185);


(lib.PurpleGreen_01 = function() {
	this.initialize(img.LevelAssets_PurpleGreen_01);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,154,221);


(lib.PurpleGreen_02 = function() {
	this.initialize(img.LevelAssets_PurpleGreen_02);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,154,221);


(lib.PurpleGreen_03 = function() {
	this.initialize(img.LevelAssets_PurpleGreen_03);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,154,184);


(lib.PurpleGreen_04 = function() {
	this.initialize(img.LevelAssets_PurpleGreen_04);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,215,235);


(lib.PurpleGreen_05 = function() {
	this.initialize(img.LevelAssets_PurpleGreen_05);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,149,221);


(lib.PurpleGreen_06 = function() {
	this.initialize(img.LevelAssets_PurpleGreen_06);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,149,205);


(lib.PurpleGreen_07 = function() {
	this.initialize(img.LevelAssets_PurpleGreen_07);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,187,221);


(lib.PurpleGreen_08 = function() {
	this.initialize(img.LevelAssets_PurpleGreen_08);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,154,184);


(lib.PurpleGreen_09 = function() {
	this.initialize(img.LevelAssets_PurpleGreen_09);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,150,184);


(lib.PurpleGreen_10 = function() {
	this.initialize(img.LevelAssets_PurpleGreen_10);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,215,235);


(lib.PurpleGreen_11 = function() {
	this.initialize(img.LevelAssets_PurpleGreen_11);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,182,184);


(lib.PurpleGreen_12 = function() {
	this.initialize(img.LevelAssets_PurpleGreen_12);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,248,235);


(lib.PurpleGreen_13 = function() {
	this.initialize(img.LevelAssets_PurpleGreen_13);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,182,184);


(lib.PurpleOrange_01 = function() {
	this.initialize(img.LevelAssets_PurpleOrange_01);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,154,220);


(lib.PurpleOrange_02 = function() {
	this.initialize(img.LevelAssets_PurpleOrange_02);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,154,220);


(lib.PurpleOrange_03 = function() {
	this.initialize(img.LevelAssets_PurpleOrange_03);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,154,184);


(lib.PurpleOrange_04 = function() {
	this.initialize(img.LevelAssets_PurpleOrange_04);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,215,235);


(lib.PurpleOrange_05 = function() {
	this.initialize(img.LevelAssets_PurpleOrange_05);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,149,220);


(lib.PurpleOrange_06 = function() {
	this.initialize(img.LevelAssets_PurpleOrange_06);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,149,204);


(lib.PurpleOrange_07 = function() {
	this.initialize(img.LevelAssets_PurpleOrange_07);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,187,220);


(lib.PurpleOrange_08 = function() {
	this.initialize(img.LevelAssets_PurpleOrange_08);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,154,185);


(lib.PurpleOrange_09 = function() {
	this.initialize(img.LevelAssets_PurpleOrange_09);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,150,185);


(lib.PurpleOrange_10 = function() {
	this.initialize(img.LevelAssets_PurpleOrange_10);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,215,235);


(lib.PurpleOrange_11 = function() {
	this.initialize(img.LevelAssets_PurpleOrange_11);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,182,185);


(lib.PurpleOrange_12 = function() {
	this.initialize(img.LevelAssets_PurpleOrange_12);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,248,235);


(lib.PurpleOrange_13 = function() {
	this.initialize(img.LevelAssets_PurpleOrange_13);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,182,185);


(lib.Tree_01 = function() {
	this.initialize(img.LevelAssets_Tree_01);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1785,2642);


(lib.Tree_02 = function() {
	this.initialize(img.LevelAssets_Tree_02);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1399,2593);// helper functions:

function mc_symbol_clone() {
	var clone = this._cloneProps(new this.constructor(this.mode, this.startPosition, this.loop, this.reversed));
	clone.gotoAndStop(this.currentFrame);
	clone.paused = this.paused;
	clone.framerate = this.framerate;
	return clone;
}

function getMCSymbolPrototype(symbol, nominalBounds, frameBounds) {
	var prototype = cjs.extend(symbol, cjs.MovieClip);
	prototype.clone = mc_symbol_clone;
	prototype.nominalBounds = nominalBounds;
	prototype.frameBounds = frameBounds;
	return prototype;
	}


(lib.BirdPlaceholder = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_2
	this.instance = new lib.BlueOrange_12();
	this.instance.setTransform(-132.7,-213.75,0.91,0.91);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.BirdPlaceholder, new cjs.Rectangle(-132.7,-213.7,225.7,213.79999999999998), null);


(lib.Location2Skin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Slots
	this.slot85 = new lib.BirdPlaceholder();
	this.slot85.name = "slot85";
	this.slot85.setTransform(4866.25,1321,1,1,0,0,180);

	this.slot80 = new lib.BirdPlaceholder();
	this.slot80.name = "slot80";
	this.slot80.setTransform(4646.55,2083.9,1,1,0,0,180);

	this.slot82 = new lib.BirdPlaceholder();
	this.slot82.name = "slot82";
	this.slot82.setTransform(4758.45,1174.3);

	this.slot90 = new lib.BirdPlaceholder();
	this.slot90.name = "slot90";
	this.slot90.setTransform(5074.3,1757.4);

	this.slot0 = new lib.BirdPlaceholder();
	this.slot0.name = "slot0";
	this.slot0.setTransform(217.65,1074.25);

	this.slot3 = new lib.BirdPlaceholder();
	this.slot3.name = "slot3";
	this.slot3.setTransform(302.4,530.55);

	this.slot9 = new lib.BirdPlaceholder();
	this.slot9.name = "slot9";
	this.slot9.setTransform(511.25,710.85,1,1,0,0,180);

	this.slot13 = new lib.BirdPlaceholder();
	this.slot13.name = "slot13";
	this.slot13.setTransform(588.6,1741.2,1,1,0,0,180);

	this.slot7 = new lib.BirdPlaceholder();
	this.slot7.name = "slot7";
	this.slot7.setTransform(445,1351);

	this.slot12 = new lib.BirdPlaceholder();
	this.slot12.name = "slot12";
	this.slot12.setTransform(566.6,1275.6);

	this.slot15 = new lib.BirdPlaceholder();
	this.slot15.name = "slot15";
	this.slot15.setTransform(653.4,1137.15,1,1,0,0,180);

	this.slot18 = new lib.BirdPlaceholder();
	this.slot18.name = "slot18";
	this.slot18.setTransform(895.35,1832.3,1,1,0,0,180);

	this.slot10 = new lib.BirdPlaceholder();
	this.slot10.name = "slot10";
	this.slot10.setTransform(527.5,1924.15);

	this.slot1 = new lib.BirdPlaceholder();
	this.slot1.name = "slot1";
	this.slot1.setTransform(249.35,2281.3);

	this.slot4 = new lib.BirdPlaceholder();
	this.slot4.name = "slot4";
	this.slot4.setTransform(370.95,2026.5);

	this.slot6 = new lib.BirdPlaceholder();
	this.slot6.name = "slot6";
	this.slot6.setTransform(399.9,971.5);

	this.slot14 = new lib.BirdPlaceholder();
	this.slot14.name = "slot14";
	this.slot14.setTransform(638.6,1503.95,1,1,0,0,180);

	this.slot11 = new lib.BirdPlaceholder();
	this.slot11.name = "slot11";
	this.slot11.setTransform(540.1,2223.95,1,1,0,0,180);

	this.slot94 = new lib.BirdPlaceholder();
	this.slot94.name = "slot94";
	this.slot94.setTransform(5421.35,2282.6);

	this.slot95 = new lib.BirdPlaceholder();
	this.slot95.name = "slot95";
	this.slot95.setTransform(5469.75,1522.65);

	this.slot103 = new lib.BirdPlaceholder();
	this.slot103.name = "slot103";
	this.slot103.setTransform(5786.7,2037.45,1,1,0,0,180);

	this.slot99 = new lib.BirdPlaceholder();
	this.slot99.name = "slot99";
	this.slot99.setTransform(5637.75,1947.7,1,1,0,0,180);

	this.slot97 = new lib.BirdPlaceholder();
	this.slot97.name = "slot97";
	this.slot97.setTransform(5543.65,1293.45);

	this.slot98 = new lib.BirdPlaceholder();
	this.slot98.name = "slot98";
	this.slot98.setTransform(5555.1,2210.35);

	this.slot106 = new lib.BirdPlaceholder();
	this.slot106.name = "slot106";
	this.slot106.setTransform(5899.5,862.25,1,1,0,0,180);

	this.slot107 = new lib.BirdPlaceholder();
	this.slot107.name = "slot107";
	this.slot107.setTransform(5949.3,1473.95);

	this.slot96 = new lib.BirdPlaceholder();
	this.slot96.name = "slot96";
	this.slot96.setTransform(5485.35,1870.05,1,1,0,0,180);

	this.slot84 = new lib.BirdPlaceholder();
	this.slot84.name = "slot84";
	this.slot84.setTransform(4795.7,1782.65,1,1,0,0,180);

	this.slot86 = new lib.BirdPlaceholder();
	this.slot86.name = "slot86";
	this.slot86.setTransform(4911.95,2108);

	this.slot17 = new lib.BirdPlaceholder();
	this.slot17.name = "slot17";
	this.slot17.setTransform(776.65,2223.95);

	this.slot81 = new lib.BirdPlaceholder();
	this.slot81.name = "slot81";
	this.slot81.setTransform(4669.8,1507.3);

	this.slot101 = new lib.BirdPlaceholder();
	this.slot101.name = "slot101";
	this.slot101.setTransform(5717.5,1487.65,1,1,0,0,180);

	this.slot102 = new lib.BirdPlaceholder();
	this.slot102.name = "slot102";
	this.slot102.setTransform(5773.6,1174.3);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.slot102},{t:this.slot101},{t:this.slot81},{t:this.slot17},{t:this.slot86},{t:this.slot84},{t:this.slot96},{t:this.slot107},{t:this.slot106},{t:this.slot98},{t:this.slot97},{t:this.slot99},{t:this.slot103},{t:this.slot95},{t:this.slot94},{t:this.slot11},{t:this.slot14},{t:this.slot6},{t:this.slot4},{t:this.slot1},{t:this.slot10},{t:this.slot18},{t:this.slot15},{t:this.slot12},{t:this.slot7},{t:this.slot13},{t:this.slot9},{t:this.slot3},{t:this.slot0},{t:this.slot90},{t:this.slot82},{t:this.slot80},{t:this.slot85}]}).wait(1));

	// Trees
	this.instance = new lib.Tree_01();
	this.instance.setTransform(6240,5,1,1,0,0,180);

	this.instance_1 = new lib.Tree_02();
	this.instance_1.setTransform(1081,94,1,1,0,0,180);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1},{t:this.instance}]}).wait(1));

	// Slots
	this.slot61 = new lib.BirdPlaceholder();
	this.slot61.name = "slot61";
	this.slot61.setTransform(3392.4,742.55,1,1,0,0,180);

	this.slot16 = new lib.BirdPlaceholder();
	this.slot16.name = "slot16";
	this.slot16.setTransform(690.25,802.9);

	this.slot111 = new lib.BirdPlaceholder();
	this.slot111.name = "slot111";
	this.slot111.setTransform(6174.7,488.55,1,1,0,0,180);

	this.slot105 = new lib.BirdPlaceholder();
	this.slot105.name = "slot105";
	this.slot105.setTransform(5903.15,380.85);

	this.slot109 = new lib.BirdPlaceholder();
	this.slot109.name = "slot109";
	this.slot109.setTransform(6089.65,1629.5);

	this.slot100 = new lib.BirdPlaceholder();
	this.slot100.name = "slot100";
	this.slot100.setTransform(5640.55,1670.6,1,1,0,0,180);

	this.slot74 = new lib.BirdPlaceholder();
	this.slot74.name = "slot74";
	this.slot74.setTransform(4100.1,1498.1);

	this.slot36 = new lib.BirdPlaceholder();
	this.slot36.name = "slot36";
	this.slot36.setTransform(2175.35,1434.5,1,1,0,0,180);

	this.slot22 = new lib.BirdPlaceholder();
	this.slot22.name = "slot22";
	this.slot22.setTransform(1163.55,1662.95);

	this.slot30 = new lib.BirdPlaceholder();
	this.slot30.name = "slot30";
	this.slot30.setTransform(1853.8,2071.9);

	this.slot33 = new lib.BirdPlaceholder();
	this.slot33.name = "slot33";
	this.slot33.setTransform(1992.55,1988.3);

	this.slot72 = new lib.BirdPlaceholder();
	this.slot72.name = "slot72";
	this.slot72.setTransform(4074.45,413.05,1,1,0,0,180);

	this.slot51 = new lib.BirdPlaceholder();
	this.slot51.name = "slot51";
	this.slot51.setTransform(2801.8,1064.3);

	this.slot75 = new lib.BirdPlaceholder();
	this.slot75.name = "slot75";
	this.slot75.setTransform(4188.3,2071.9);

	this.slot68 = new lib.BirdPlaceholder();
	this.slot68.name = "slot68";
	this.slot68.setTransform(3825.45,2202.15);

	this.slot71 = new lib.BirdPlaceholder();
	this.slot71.name = "slot71";
	this.slot71.setTransform(4036.2,2356.3,1,1,0,0,180);

	this.slot21 = new lib.BirdPlaceholder();
	this.slot21.name = "slot21";
	this.slot21.setTransform(1084.75,1268.45);

	this.slot23 = new lib.BirdPlaceholder();
	this.slot23.name = "slot23";
	this.slot23.setTransform(1253.45,915,1,1,0,0,180);

	this.slot52 = new lib.BirdPlaceholder();
	this.slot52.name = "slot52";
	this.slot52.setTransform(2819.15,445.85,1,1,0,0,180);

	this.slot64 = new lib.BirdPlaceholder();
	this.slot64.name = "slot64";
	this.slot64.setTransform(3447.55,570.85);

	this.slot63 = new lib.BirdPlaceholder();
	this.slot63.name = "slot63";
	this.slot63.setTransform(3420.35,357);

	this.slot39 = new lib.BirdPlaceholder();
	this.slot39.name = "slot39";
	this.slot39.setTransform(2334.6,528.7);

	this.slot43 = new lib.BirdPlaceholder();
	this.slot43.name = "slot43";
	this.slot43.setTransform(2482.5,380.85);

	this.slot46 = new lib.BirdPlaceholder();
	this.slot46.name = "slot46";
	this.slot46.setTransform(2581,509.05,1,1,0,0,180);

	this.slot48 = new lib.BirdPlaceholder();
	this.slot48.name = "slot48";
	this.slot48.setTransform(2750.3,873.55,1,1,0,0,180);

	this.slot45 = new lib.BirdPlaceholder();
	this.slot45.name = "slot45";
	this.slot45.setTransform(2567.7,892.7);

	this.slot73 = new lib.BirdPlaceholder();
	this.slot73.name = "slot73";
	this.slot73.setTransform(4127.4,1125.9);

	this.slot59 = new lib.BirdPlaceholder();
	this.slot59.name = "slot59";
	this.slot59.setTransform(3310.2,1774.45);

	this.slot60 = new lib.BirdPlaceholder();
	this.slot60.name = "slot60";
	this.slot60.setTransform(3534.1,2226.35,1,1,0,0,180);

	this.slot20 = new lib.BirdPlaceholder();
	this.slot20.name = "slot20";
	this.slot20.setTransform(1046.45,793.15);

	this.slot31 = new lib.BirdPlaceholder();
	this.slot31.name = "slot31";
	this.slot31.setTransform(1883.7,840.75,1,1,0,0,180);

	this.slot25 = new lib.BirdPlaceholder();
	this.slot25.name = "slot25";
	this.slot25.setTransform(1382.8,528.7,1,1,0,0,180);

	this.slot65 = new lib.BirdPlaceholder();
	this.slot65.name = "slot65";
	this.slot65.setTransform(3490.45,1828,1,1,0,0,180);

	this.slot66 = new lib.BirdPlaceholder();
	this.slot66.name = "slot66";
	this.slot66.setTransform(3533.15,1458.8);

	this.slot47 = new lib.BirdPlaceholder();
	this.slot47.name = "slot47";
	this.slot47.setTransform(2599.1,2142.45);

	this.slot54 = new lib.BirdPlaceholder();
	this.slot54.name = "slot54";
	this.slot54.setTransform(2924.35,1519.5,1,1,0,0,180);

	this.slot40 = new lib.BirdPlaceholder();
	this.slot40.name = "slot40";
	this.slot40.setTransform(2334.6,1828);

	this.slot53 = new lib.BirdPlaceholder();
	this.slot53.name = "slot53";
	this.slot53.setTransform(2855.5,1949.05,1,1,0,0,180);

	this.slot29 = new lib.BirdPlaceholder();
	this.slot29.name = "slot29";
	this.slot29.setTransform(1760.3,1367.95,1,1,0,0,180);

	this.slot37 = new lib.BirdPlaceholder();
	this.slot37.name = "slot37";
	this.slot37.setTransform(2222.2,840.75);

	this.slot35 = new lib.BirdPlaceholder();
	this.slot35.name = "slot35";
	this.slot35.setTransform(2172,1128.85);

	this.slot57 = new lib.BirdPlaceholder();
	this.slot57.name = "slot57";
	this.slot57.setTransform(3056.55,2205.85,1,1,0,0,180);

	this.slot50 = new lib.BirdPlaceholder();
	this.slot50.name = "slot50";
	this.slot50.setTransform(2776.65,2117.85,1,1,0,0,180);

	this.slot67 = new lib.BirdPlaceholder();
	this.slot67.name = "slot67";
	this.slot67.setTransform(3816.05,1714.75);

	this.slot69 = new lib.BirdPlaceholder();
	this.slot69.name = "slot69";
	this.slot69.setTransform(3948.55,892.7);

	this.slot41 = new lib.BirdPlaceholder();
	this.slot41.name = "slot41";
	this.slot41.setTransform(2388.35,2401.9);

	this.slot44 = new lib.BirdPlaceholder();
	this.slot44.name = "slot44";
	this.slot44.setTransform(2514.25,1890.3,1,1,0,0,180);

	this.slot26 = new lib.BirdPlaceholder();
	this.slot26.name = "slot26";
	this.slot26.setTransform(1443.3,1220.65);

	this.slot32 = new lib.BirdPlaceholder();
	this.slot32.name = "slot32";
	this.slot32.setTransform(1883.7,1711.95,1,1,0,0,180);

	this.slot42 = new lib.BirdPlaceholder();
	this.slot42.name = "slot42";
	this.slot42.setTransform(2412.75,1711.95,1,1,0,0,180);

	this.slot76 = new lib.BirdPlaceholder();
	this.slot76.name = "slot76";
	this.slot76.setTransform(4238.65,1433.55,1,1,0,0,180);

	this.slot34 = new lib.BirdPlaceholder();
	this.slot34.name = "slot34";
	this.slot34.setTransform(1994.8,626.9,1,1,0,0,180);

	this.slot28 = new lib.BirdPlaceholder();
	this.slot28.name = "slot28";
	this.slot28.setTransform(1621.5,924.55,1,1,0,0,180);

	this.slot49 = new lib.BirdPlaceholder();
	this.slot49.name = "slot49";
	this.slot49.setTransform(2763.35,1581.8);

	this.slot38 = new lib.BirdPlaceholder();
	this.slot38.name = "slot38";
	this.slot38.setTransform(2317.95,1354.25);

	this.slot79 = new lib.BirdPlaceholder();
	this.slot79.name = "slot79";
	this.slot79.setTransform(4623.45,2353.55);

	this.slot83 = new lib.BirdPlaceholder();
	this.slot83.name = "slot83";
	this.slot83.setTransform(4792.35,2373.55,1,1,0,0,180);

	this.slot24 = new lib.BirdPlaceholder();
	this.slot24.name = "slot24";
	this.slot24.setTransform(1325.95,1616.8,1,1,0,0,180);

	this.slot27 = new lib.BirdPlaceholder();
	this.slot27.name = "slot27";
	this.slot27.setTransform(1493.75,2226.35,1,1,0,0,180);

	this.slot113 = new lib.BirdPlaceholder();
	this.slot113.name = "slot113";
	this.slot113.setTransform(6318.15,808.55);

	this.slot112 = new lib.BirdPlaceholder();
	this.slot112.name = "slot112";
	this.slot112.setTransform(6269.2,1838.7,1,1,0,0,180);

	this.slot8 = new lib.BirdPlaceholder();
	this.slot8.name = "slot8";
	this.slot8.setTransform(499.65,2408.1,1,1,0,0,180);

	this.slot108 = new lib.BirdPlaceholder();
	this.slot108.name = "slot108";
	this.slot108.setTransform(6074.85,2223.95);

	this.slot110 = new lib.BirdPlaceholder();
	this.slot110.name = "slot110";
	this.slot110.setTransform(6231.4,2516.3);

	this.slot104 = new lib.BirdPlaceholder();
	this.slot104.name = "slot104";
	this.slot104.setTransform(5673.85,2496.45,1,1,0,0,180);

	this.slot5 = new lib.BirdPlaceholder();
	this.slot5.name = "slot5";
	this.slot5.setTransform(373.75,1637.7);

	this.slot62 = new lib.BirdPlaceholder();
	this.slot62.name = "slot62";
	this.slot62.setTransform(3392.4,1087.4,1,1,0,0,180);

	this.slot56 = new lib.BirdPlaceholder();
	this.slot56.name = "slot56";
	this.slot56.setTransform(3062.55,1148.1,1,1,0,0,180);

	this.slot88 = new lib.BirdPlaceholder();
	this.slot88.name = "slot88";
	this.slot88.setTransform(4966.65,1608.1,1,1,0,0,180);

	this.slot92 = new lib.BirdPlaceholder();
	this.slot92.name = "slot92";
	this.slot92.setTransform(5110.95,1283.75,1,1,0,0,180);

	this.slot77 = new lib.BirdPlaceholder();
	this.slot77.name = "slot77";
	this.slot77.setTransform(4427.8,429.7);

	this.slot78 = new lib.BirdPlaceholder();
	this.slot78.name = "slot78";
	this.slot78.setTransform(4573.5,347.3);

	this.slot19 = new lib.BirdPlaceholder();
	this.slot19.name = "slot19";
	this.slot19.setTransform(1039.85,2048.6,1,1,0,0,180);

	this.slot2 = new lib.BirdPlaceholder();
	this.slot2.name = "slot2";
	this.slot2.setTransform(276.4,2516.3);

	this.slot55 = new lib.BirdPlaceholder();
	this.slot55.name = "slot55";
	this.slot55.setTransform(3364.55,2187.75);

	this.slot70 = new lib.BirdPlaceholder();
	this.slot70.name = "slot70";
	this.slot70.setTransform(3951.35,773.6,1,1,0,0,180);

	this.slot58 = new lib.BirdPlaceholder();
	this.slot58.name = "slot58";
	this.slot58.setTransform(3143.6,488.55,1,1,0,0,180);

	this.slot89 = new lib.BirdPlaceholder();
	this.slot89.name = "slot89";
	this.slot89.setTransform(4988,870.15,1,1,0,0,180);

	this.slot87 = new lib.BirdPlaceholder();
	this.slot87.name = "slot87";
	this.slot87.setTransform(4956.9,753.55);

	this.slot93 = new lib.BirdPlaceholder();
	this.slot93.name = "slot93";
	this.slot93.setTransform(5306.6,820.7,1,1,0,0,180);

	this.slot91 = new lib.BirdPlaceholder();
	this.slot91.name = "slot91";
	this.slot91.setTransform(5110.4,769.7);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.slot91},{t:this.slot93},{t:this.slot87},{t:this.slot89},{t:this.slot58},{t:this.slot70},{t:this.slot55},{t:this.slot2},{t:this.slot19},{t:this.slot78},{t:this.slot77},{t:this.slot92},{t:this.slot88},{t:this.slot56},{t:this.slot62},{t:this.slot5},{t:this.slot104},{t:this.slot110},{t:this.slot108},{t:this.slot8},{t:this.slot112},{t:this.slot113},{t:this.slot27},{t:this.slot24},{t:this.slot83},{t:this.slot79},{t:this.slot38},{t:this.slot49},{t:this.slot28},{t:this.slot34},{t:this.slot76},{t:this.slot42},{t:this.slot32},{t:this.slot26},{t:this.slot44},{t:this.slot41},{t:this.slot69},{t:this.slot67},{t:this.slot50},{t:this.slot57},{t:this.slot35},{t:this.slot37},{t:this.slot29},{t:this.slot53},{t:this.slot40},{t:this.slot54},{t:this.slot47},{t:this.slot66},{t:this.slot65},{t:this.slot25},{t:this.slot31},{t:this.slot20},{t:this.slot60},{t:this.slot59},{t:this.slot73},{t:this.slot45},{t:this.slot48},{t:this.slot46},{t:this.slot43},{t:this.slot39},{t:this.slot63},{t:this.slot64},{t:this.slot52},{t:this.slot23},{t:this.slot21},{t:this.slot71},{t:this.slot68},{t:this.slot75},{t:this.slot51},{t:this.slot72},{t:this.slot33},{t:this.slot30},{t:this.slot22},{t:this.slot36},{t:this.slot74},{t:this.slot100},{t:this.slot109},{t:this.slot105},{t:this.slot111},{t:this.slot16},{t:this.slot61}]}).wait(1));

	// Background 5 tiles bitmaps
	this.instance_2 = new lib.Location1Layer1_15();
	this.instance_2.setTransform(5184,0);

	this.instance_3 = new lib.Location1Layer1_14();
	this.instance_3.setTransform(3887,0);

	this.instance_4 = new lib.Location1Layer1_13();
	this.instance_4.setTransform(2592,0);

	this.instance_5 = new lib.Location1Layer1_11();

	this.instance_6 = new lib.Location1Layer1_12();
	this.instance_6.setTransform(1295,0);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_6},{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Location2Skin, new cjs.Rectangle(-318,-784.2,6799,3784.2), null);


// stage content:
(lib.LevelAssetsRedesign = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Birds
	this.instance = new lib.PurpleOrange_13();
	this.instance.setTransform(-827,-810);

	this.instance_1 = new lib.PurpleOrange_12();
	this.instance_1.setTransform(-827,-810);

	this.instance_2 = new lib.PurpleOrange_11();
	this.instance_2.setTransform(-827,-810);

	this.instance_3 = new lib.PurpleOrange_10();
	this.instance_3.setTransform(-827,-810);

	this.instance_4 = new lib.PurpleOrange_09();
	this.instance_4.setTransform(-827,-810);

	this.instance_5 = new lib.PurpleOrange_08();
	this.instance_5.setTransform(-827,-810);

	this.instance_6 = new lib.PurpleOrange_07();
	this.instance_6.setTransform(-827,-810);

	this.instance_7 = new lib.PurpleOrange_06();
	this.instance_7.setTransform(-827,-810);

	this.instance_8 = new lib.PurpleOrange_05();
	this.instance_8.setTransform(-827,-810);

	this.instance_9 = new lib.PurpleOrange_04();
	this.instance_9.setTransform(-827,-810);

	this.instance_10 = new lib.PurpleOrange_03();
	this.instance_10.setTransform(-827,-810);

	this.instance_11 = new lib.PurpleOrange_02();
	this.instance_11.setTransform(-827,-810);

	this.instance_12 = new lib.PurpleOrange_01();
	this.instance_12.setTransform(-827,-810);

	this.instance_13 = new lib.PurpleGreen_13();
	this.instance_13.setTransform(-827,-810);

	this.instance_14 = new lib.PurpleGreen_12();
	this.instance_14.setTransform(-827,-810);

	this.instance_15 = new lib.PurpleGreen_11();
	this.instance_15.setTransform(-827,-810);

	this.instance_16 = new lib.PurpleGreen_10();
	this.instance_16.setTransform(-827,-810);

	this.instance_17 = new lib.PurpleGreen_09();
	this.instance_17.setTransform(-827,-810);

	this.instance_18 = new lib.PurpleGreen_08();
	this.instance_18.setTransform(-827,-810);

	this.instance_19 = new lib.PurpleGreen_07();
	this.instance_19.setTransform(-827,-810);

	this.instance_20 = new lib.PurpleGreen_06();
	this.instance_20.setTransform(-827,-810);

	this.instance_21 = new lib.PurpleGreen_05();
	this.instance_21.setTransform(-827,-810);

	this.instance_22 = new lib.PurpleGreen_04();
	this.instance_22.setTransform(-827,-810);

	this.instance_23 = new lib.PurpleGreen_03();
	this.instance_23.setTransform(-827,-810);

	this.instance_24 = new lib.PurpleGreen_02();
	this.instance_24.setTransform(-827,-810);

	this.instance_25 = new lib.PurpleGreen_01();
	this.instance_25.setTransform(-827,-810);

	this.instance_26 = new lib.OrangePurple_13();
	this.instance_26.setTransform(-827,-810);

	this.instance_27 = new lib.OrangePurple_12();
	this.instance_27.setTransform(-827,-810);

	this.instance_28 = new lib.OrangePurple_11();
	this.instance_28.setTransform(-827,-810);

	this.instance_29 = new lib.OrangePurple_10();
	this.instance_29.setTransform(-827,-810);

	this.instance_30 = new lib.OrangePurple_09();
	this.instance_30.setTransform(-827,-810);

	this.instance_31 = new lib.OrangePurple_08();
	this.instance_31.setTransform(-827,-810);

	this.instance_32 = new lib.OrangePurple_07();
	this.instance_32.setTransform(-827,-810);

	this.instance_33 = new lib.OrangePurple_06();
	this.instance_33.setTransform(-827,-810);

	this.instance_34 = new lib.OrangePurple_05();
	this.instance_34.setTransform(-827,-810);

	this.instance_35 = new lib.OrangePurple_04();
	this.instance_35.setTransform(-827,-810);

	this.instance_36 = new lib.OrangePurple_03();
	this.instance_36.setTransform(-827,-810);

	this.instance_37 = new lib.OrangePurple_02();
	this.instance_37.setTransform(-827,-810);

	this.instance_38 = new lib.OrangePurple_01();
	this.instance_38.setTransform(-827,-810);

	this.instance_39 = new lib.OrangeGreen_13();
	this.instance_39.setTransform(-827,-810);

	this.instance_40 = new lib.OrangeGreen_12();
	this.instance_40.setTransform(-827,-810);

	this.instance_41 = new lib.OrangeGreen_11();
	this.instance_41.setTransform(-827,-810);

	this.instance_42 = new lib.OrangeGreen_10();
	this.instance_42.setTransform(-827,-810);

	this.instance_43 = new lib.OrangeGreen_09();
	this.instance_43.setTransform(-827,-810);

	this.instance_44 = new lib.OrangeGreen_08();
	this.instance_44.setTransform(-827,-810);

	this.instance_45 = new lib.OrangeGreen_07();
	this.instance_45.setTransform(-827,-810);

	this.instance_46 = new lib.OrangeGreen_06();
	this.instance_46.setTransform(-827,-810);

	this.instance_47 = new lib.OrangeGreen_05();
	this.instance_47.setTransform(-827,-810);

	this.instance_48 = new lib.OrangeGreen_04();
	this.instance_48.setTransform(-827,-810);

	this.instance_49 = new lib.OrangeGreen_03();
	this.instance_49.setTransform(-827,-810);

	this.instance_50 = new lib.OrangeGreen_02();
	this.instance_50.setTransform(-827,-810);

	this.instance_51 = new lib.OrangeGreen_01();
	this.instance_51.setTransform(-827,-810);

	this.instance_52 = new lib.GreenOrange_13();
	this.instance_52.setTransform(-827,-810);

	this.instance_53 = new lib.GreenOrange_12();
	this.instance_53.setTransform(-827,-810);

	this.instance_54 = new lib.GreenOrange_11();
	this.instance_54.setTransform(-827,-810);

	this.instance_55 = new lib.GreenOrange_10();
	this.instance_55.setTransform(-827,-810);

	this.instance_56 = new lib.GreenOrange_09();
	this.instance_56.setTransform(-827,-810);

	this.instance_57 = new lib.GreenOrange_08();
	this.instance_57.setTransform(-827,-810);

	this.instance_58 = new lib.GreenOrange_07();
	this.instance_58.setTransform(-827,-810);

	this.instance_59 = new lib.GreenOrange_06();
	this.instance_59.setTransform(-827,-810);

	this.instance_60 = new lib.GreenOrange_05();
	this.instance_60.setTransform(-827,-810);

	this.instance_61 = new lib.GreenOrange_04();
	this.instance_61.setTransform(-827,-810);

	this.instance_62 = new lib.GreenOrange_03();
	this.instance_62.setTransform(-827,-810);

	this.instance_63 = new lib.GreenOrange_02();
	this.instance_63.setTransform(-827,-810);

	this.instance_64 = new lib.GreenOrange_01();
	this.instance_64.setTransform(-827,-810);

	this.instance_65 = new lib.GreenBlue_13();
	this.instance_65.setTransform(-827,-810);

	this.instance_66 = new lib.GreenBlue_12();
	this.instance_66.setTransform(-827,-810);

	this.instance_67 = new lib.GreenBlue_11();
	this.instance_67.setTransform(-827,-810);

	this.instance_68 = new lib.GreenBlue_10();
	this.instance_68.setTransform(-827,-810);

	this.instance_69 = new lib.GreenBlue_09();
	this.instance_69.setTransform(-827,-810);

	this.instance_70 = new lib.GreenBlue_08();
	this.instance_70.setTransform(-827,-810);

	this.instance_71 = new lib.GreenBlue_07();
	this.instance_71.setTransform(-827,-810);

	this.instance_72 = new lib.GreenBlue_06();
	this.instance_72.setTransform(-827,-810);

	this.instance_73 = new lib.GreenBlue_05();
	this.instance_73.setTransform(-827,-810);

	this.instance_74 = new lib.GreenBlue_04();
	this.instance_74.setTransform(-827,-810);

	this.instance_75 = new lib.GreenBlue_03();
	this.instance_75.setTransform(-827,-810);

	this.instance_76 = new lib.GreenBlue_02();
	this.instance_76.setTransform(-827,-810);

	this.instance_77 = new lib.GreenBlue_01();
	this.instance_77.setTransform(-827,-810);

	this.instance_78 = new lib.BlueOrange_13();
	this.instance_78.setTransform(-827,-810);

	this.instance_79 = new lib.BlueOrange_12();
	this.instance_79.setTransform(-827,-810);

	this.instance_80 = new lib.BlueOrange_11();
	this.instance_80.setTransform(-827,-810);

	this.instance_81 = new lib.BlueOrange_10();
	this.instance_81.setTransform(-827,-810);

	this.instance_82 = new lib.BlueOrange_09();
	this.instance_82.setTransform(-827,-810);

	this.instance_83 = new lib.BlueOrange_08();
	this.instance_83.setTransform(-827,-810);

	this.instance_84 = new lib.BlueOrange_07();
	this.instance_84.setTransform(-827,-810);

	this.instance_85 = new lib.BlueOrange_06();
	this.instance_85.setTransform(-827,-810);

	this.instance_86 = new lib.BlueOrange_05();
	this.instance_86.setTransform(-827,-810);

	this.instance_87 = new lib.BlueOrange_04();
	this.instance_87.setTransform(-827,-810);

	this.instance_88 = new lib.BlueOrange_03();
	this.instance_88.setTransform(-827,-810);

	this.instance_89 = new lib.BlueOrange_02();
	this.instance_89.setTransform(-827,-810);

	this.instance_90 = new lib.BlueOrange_01();
	this.instance_90.setTransform(-827,-810);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_90},{t:this.instance_89},{t:this.instance_88},{t:this.instance_87},{t:this.instance_86},{t:this.instance_85},{t:this.instance_84},{t:this.instance_83},{t:this.instance_82},{t:this.instance_81},{t:this.instance_80},{t:this.instance_79},{t:this.instance_78},{t:this.instance_77},{t:this.instance_76},{t:this.instance_75},{t:this.instance_74},{t:this.instance_73},{t:this.instance_72},{t:this.instance_71},{t:this.instance_70},{t:this.instance_69},{t:this.instance_68},{t:this.instance_67},{t:this.instance_66},{t:this.instance_65},{t:this.instance_64},{t:this.instance_63},{t:this.instance_62},{t:this.instance_61},{t:this.instance_60},{t:this.instance_59},{t:this.instance_58},{t:this.instance_57},{t:this.instance_56},{t:this.instance_55},{t:this.instance_54},{t:this.instance_53},{t:this.instance_52},{t:this.instance_51},{t:this.instance_50},{t:this.instance_49},{t:this.instance_48},{t:this.instance_47},{t:this.instance_46},{t:this.instance_45},{t:this.instance_44},{t:this.instance_43},{t:this.instance_42},{t:this.instance_41},{t:this.instance_40},{t:this.instance_39},{t:this.instance_38},{t:this.instance_37},{t:this.instance_36},{t:this.instance_35},{t:this.instance_34},{t:this.instance_33},{t:this.instance_32},{t:this.instance_31},{t:this.instance_30},{t:this.instance_29},{t:this.instance_28},{t:this.instance_27},{t:this.instance_26},{t:this.instance_25},{t:this.instance_24},{t:this.instance_23},{t:this.instance_22},{t:this.instance_21},{t:this.instance_20},{t:this.instance_19},{t:this.instance_18},{t:this.instance_17},{t:this.instance_16},{t:this.instance_15},{t:this.instance_14},{t:this.instance_13},{t:this.instance_12},{t:this.instance_11},{t:this.instance_10},{t:this.instance_9},{t:this.instance_8},{t:this.instance_7},{t:this.instance_6},{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]}).wait(1));

	// Locations
	this.instance_91 = new lib.Location2Skin();
	this.instance_91.setTransform(-2636.7,-284.05);

	this.timeline.addTween(cjs.Tween.get(this.instance_91).wait(1));

	this._renderFirstFrame();

}).prototype = p = new lib.AnMovieClip();
p.nominalBounds = new cjs.Rectangle(-6618.4,61,15113.6,13792);
// library properties:
lib.properties = {
	id: '2D758ABF18A3194E856740076AC96F36',
	width: 1080,
	height: 1742,
	fps: 24,
	color: "#333333",
	opacity: 1.00,
	manifest: [
		{src:"assets/skins/images/LevelAssets/BlueOrange_01.png", id:"LevelAssets_BlueOrange_01", bundle:"LevelAssets"},
		{src:"assets/skins/images/LevelAssets/BlueOrange_02.png", id:"LevelAssets_BlueOrange_02", bundle:"LevelAssets"},
		{src:"assets/skins/images/LevelAssets/BlueOrange_03.png", id:"LevelAssets_BlueOrange_03", bundle:"LevelAssets"},
		{src:"assets/skins/images/LevelAssets/BlueOrange_04.png", id:"LevelAssets_BlueOrange_04", bundle:"LevelAssets"},
		{src:"assets/skins/images/LevelAssets/BlueOrange_05.png", id:"LevelAssets_BlueOrange_05", bundle:"LevelAssets"},
		{src:"assets/skins/images/LevelAssets/BlueOrange_06.png", id:"LevelAssets_BlueOrange_06", bundle:"LevelAssets"},
		{src:"assets/skins/images/LevelAssets/BlueOrange_07.png", id:"LevelAssets_BlueOrange_07", bundle:"LevelAssets"},
		{src:"assets/skins/images/LevelAssets/BlueOrange_08.png", id:"LevelAssets_BlueOrange_08", bundle:"LevelAssets"},
		{src:"assets/skins/images/LevelAssets/BlueOrange_09.png", id:"LevelAssets_BlueOrange_09", bundle:"LevelAssets"},
		{src:"assets/skins/images/LevelAssets/BlueOrange_10.png", id:"LevelAssets_BlueOrange_10", bundle:"LevelAssets"},
		{src:"assets/skins/images/LevelAssets/BlueOrange_11.png", id:"LevelAssets_BlueOrange_11", bundle:"LevelAssets"},
		{src:"assets/skins/images/LevelAssets/BlueOrange_12.png", id:"LevelAssets_BlueOrange_12", bundle:"LevelAssets"},
		{src:"assets/skins/images/LevelAssets/BlueOrange_13.png", id:"LevelAssets_BlueOrange_13", bundle:"LevelAssets"},
		{src:"assets/skins/images/LevelAssets/GreenBlue_01.png", id:"LevelAssets_GreenBlue_01", bundle:"LevelAssets"},
		{src:"assets/skins/images/LevelAssets/GreenBlue_02.png", id:"LevelAssets_GreenBlue_02", bundle:"LevelAssets"},
		{src:"assets/skins/images/LevelAssets/GreenBlue_03.png", id:"LevelAssets_GreenBlue_03", bundle:"LevelAssets"},
		{src:"assets/skins/images/LevelAssets/GreenBlue_04.png", id:"LevelAssets_GreenBlue_04", bundle:"LevelAssets"},
		{src:"assets/skins/images/LevelAssets/GreenBlue_05.png", id:"LevelAssets_GreenBlue_05", bundle:"LevelAssets"},
		{src:"assets/skins/images/LevelAssets/GreenBlue_06.png", id:"LevelAssets_GreenBlue_06", bundle:"LevelAssets"},
		{src:"assets/skins/images/LevelAssets/GreenBlue_07.png", id:"LevelAssets_GreenBlue_07", bundle:"LevelAssets"},
		{src:"assets/skins/images/LevelAssets/GreenBlue_08.png", id:"LevelAssets_GreenBlue_08", bundle:"LevelAssets"},
		{src:"assets/skins/images/LevelAssets/GreenBlue_09.png", id:"LevelAssets_GreenBlue_09", bundle:"LevelAssets"},
		{src:"assets/skins/images/LevelAssets/GreenBlue_10.png", id:"LevelAssets_GreenBlue_10", bundle:"LevelAssets"},
		{src:"assets/skins/images/LevelAssets/GreenBlue_11.png", id:"LevelAssets_GreenBlue_11", bundle:"LevelAssets"},
		{src:"assets/skins/images/LevelAssets/GreenBlue_12.png", id:"LevelAssets_GreenBlue_12", bundle:"LevelAssets"},
		{src:"assets/skins/images/LevelAssets/GreenBlue_13.png", id:"LevelAssets_GreenBlue_13", bundle:"LevelAssets"},
		{src:"assets/skins/images/LevelAssets/GreenOrange_01.png", id:"LevelAssets_GreenOrange_01", bundle:"LevelAssets"},
		{src:"assets/skins/images/LevelAssets/GreenOrange_02.png", id:"LevelAssets_GreenOrange_02", bundle:"LevelAssets"},
		{src:"assets/skins/images/LevelAssets/GreenOrange_03.png", id:"LevelAssets_GreenOrange_03", bundle:"LevelAssets"},
		{src:"assets/skins/images/LevelAssets/GreenOrange_04.png", id:"LevelAssets_GreenOrange_04", bundle:"LevelAssets"},
		{src:"assets/skins/images/LevelAssets/GreenOrange_05.png", id:"LevelAssets_GreenOrange_05", bundle:"LevelAssets"},
		{src:"assets/skins/images/LevelAssets/GreenOrange_06.png", id:"LevelAssets_GreenOrange_06", bundle:"LevelAssets"},
		{src:"assets/skins/images/LevelAssets/GreenOrange_07.png", id:"LevelAssets_GreenOrange_07", bundle:"LevelAssets"},
		{src:"assets/skins/images/LevelAssets/GreenOrange_08.png", id:"LevelAssets_GreenOrange_08", bundle:"LevelAssets"},
		{src:"assets/skins/images/LevelAssets/GreenOrange_09.png", id:"LevelAssets_GreenOrange_09", bundle:"LevelAssets"},
		{src:"assets/skins/images/LevelAssets/GreenOrange_10.png", id:"LevelAssets_GreenOrange_10", bundle:"LevelAssets"},
		{src:"assets/skins/images/LevelAssets/GreenOrange_11.png", id:"LevelAssets_GreenOrange_11", bundle:"LevelAssets"},
		{src:"assets/skins/images/LevelAssets/GreenOrange_12.png", id:"LevelAssets_GreenOrange_12", bundle:"LevelAssets"},
		{src:"assets/skins/images/LevelAssets/GreenOrange_13.png", id:"LevelAssets_GreenOrange_13", bundle:"LevelAssets"},
		{src:"assets/skins/images/LevelAssets/Location1Layer1_11.png", id:"LevelAssets_Location1Layer1_11", bundle:"LevelAssets"},
		{src:"assets/skins/images/LevelAssets/Location1Layer1_12.png", id:"LevelAssets_Location1Layer1_12", bundle:"LevelAssets"},
		{src:"assets/skins/images/LevelAssets/Location1Layer1_13.png", id:"LevelAssets_Location1Layer1_13", bundle:"LevelAssets"},
		{src:"assets/skins/images/LevelAssets/Location1Layer1_14.png", id:"LevelAssets_Location1Layer1_14", bundle:"LevelAssets"},
		{src:"assets/skins/images/LevelAssets/Location1Layer1_15.png", id:"LevelAssets_Location1Layer1_15", bundle:"LevelAssets"},
		{src:"assets/skins/images/LevelAssets/OrangeGreen_01.png", id:"LevelAssets_OrangeGreen_01", bundle:"LevelAssets"},
		{src:"assets/skins/images/LevelAssets/OrangeGreen_02.png", id:"LevelAssets_OrangeGreen_02", bundle:"LevelAssets"},
		{src:"assets/skins/images/LevelAssets/OrangeGreen_03.png", id:"LevelAssets_OrangeGreen_03", bundle:"LevelAssets"},
		{src:"assets/skins/images/LevelAssets/OrangeGreen_04.png", id:"LevelAssets_OrangeGreen_04", bundle:"LevelAssets"},
		{src:"assets/skins/images/LevelAssets/OrangeGreen_05.png", id:"LevelAssets_OrangeGreen_05", bundle:"LevelAssets"},
		{src:"assets/skins/images/LevelAssets/OrangeGreen_06.png", id:"LevelAssets_OrangeGreen_06", bundle:"LevelAssets"},
		{src:"assets/skins/images/LevelAssets/OrangeGreen_07.png", id:"LevelAssets_OrangeGreen_07", bundle:"LevelAssets"},
		{src:"assets/skins/images/LevelAssets/OrangeGreen_08.png", id:"LevelAssets_OrangeGreen_08", bundle:"LevelAssets"},
		{src:"assets/skins/images/LevelAssets/OrangeGreen_09.png", id:"LevelAssets_OrangeGreen_09", bundle:"LevelAssets"},
		{src:"assets/skins/images/LevelAssets/OrangeGreen_10.png", id:"LevelAssets_OrangeGreen_10", bundle:"LevelAssets"},
		{src:"assets/skins/images/LevelAssets/OrangeGreen_11.png", id:"LevelAssets_OrangeGreen_11", bundle:"LevelAssets"},
		{src:"assets/skins/images/LevelAssets/OrangeGreen_12.png", id:"LevelAssets_OrangeGreen_12", bundle:"LevelAssets"},
		{src:"assets/skins/images/LevelAssets/OrangeGreen_13.png", id:"LevelAssets_OrangeGreen_13", bundle:"LevelAssets"},
		{src:"assets/skins/images/LevelAssets/OrangePurple_01.png", id:"LevelAssets_OrangePurple_01", bundle:"LevelAssets"},
		{src:"assets/skins/images/LevelAssets/OrangePurple_02.png", id:"LevelAssets_OrangePurple_02", bundle:"LevelAssets"},
		{src:"assets/skins/images/LevelAssets/OrangePurple_03.png", id:"LevelAssets_OrangePurple_03", bundle:"LevelAssets"},
		{src:"assets/skins/images/LevelAssets/OrangePurple_04.png", id:"LevelAssets_OrangePurple_04", bundle:"LevelAssets"},
		{src:"assets/skins/images/LevelAssets/OrangePurple_05.png", id:"LevelAssets_OrangePurple_05", bundle:"LevelAssets"},
		{src:"assets/skins/images/LevelAssets/OrangePurple_06.png", id:"LevelAssets_OrangePurple_06", bundle:"LevelAssets"},
		{src:"assets/skins/images/LevelAssets/OrangePurple_07.png", id:"LevelAssets_OrangePurple_07", bundle:"LevelAssets"},
		{src:"assets/skins/images/LevelAssets/OrangePurple_08.png", id:"LevelAssets_OrangePurple_08", bundle:"LevelAssets"},
		{src:"assets/skins/images/LevelAssets/OrangePurple_09.png", id:"LevelAssets_OrangePurple_09", bundle:"LevelAssets"},
		{src:"assets/skins/images/LevelAssets/OrangePurple_10.png", id:"LevelAssets_OrangePurple_10", bundle:"LevelAssets"},
		{src:"assets/skins/images/LevelAssets/OrangePurple_11.png", id:"LevelAssets_OrangePurple_11", bundle:"LevelAssets"},
		{src:"assets/skins/images/LevelAssets/OrangePurple_12.png", id:"LevelAssets_OrangePurple_12", bundle:"LevelAssets"},
		{src:"assets/skins/images/LevelAssets/OrangePurple_13.png", id:"LevelAssets_OrangePurple_13", bundle:"LevelAssets"},
		{src:"assets/skins/images/LevelAssets/PurpleGreen_01.png", id:"LevelAssets_PurpleGreen_01", bundle:"LevelAssets"},
		{src:"assets/skins/images/LevelAssets/PurpleGreen_02.png", id:"LevelAssets_PurpleGreen_02", bundle:"LevelAssets"},
		{src:"assets/skins/images/LevelAssets/PurpleGreen_03.png", id:"LevelAssets_PurpleGreen_03", bundle:"LevelAssets"},
		{src:"assets/skins/images/LevelAssets/PurpleGreen_04.png", id:"LevelAssets_PurpleGreen_04", bundle:"LevelAssets"},
		{src:"assets/skins/images/LevelAssets/PurpleGreen_05.png", id:"LevelAssets_PurpleGreen_05", bundle:"LevelAssets"},
		{src:"assets/skins/images/LevelAssets/PurpleGreen_06.png", id:"LevelAssets_PurpleGreen_06", bundle:"LevelAssets"},
		{src:"assets/skins/images/LevelAssets/PurpleGreen_07.png", id:"LevelAssets_PurpleGreen_07", bundle:"LevelAssets"},
		{src:"assets/skins/images/LevelAssets/PurpleGreen_08.png", id:"LevelAssets_PurpleGreen_08", bundle:"LevelAssets"},
		{src:"assets/skins/images/LevelAssets/PurpleGreen_09.png", id:"LevelAssets_PurpleGreen_09", bundle:"LevelAssets"},
		{src:"assets/skins/images/LevelAssets/PurpleGreen_10.png", id:"LevelAssets_PurpleGreen_10", bundle:"LevelAssets"},
		{src:"assets/skins/images/LevelAssets/PurpleGreen_11.png", id:"LevelAssets_PurpleGreen_11", bundle:"LevelAssets"},
		{src:"assets/skins/images/LevelAssets/PurpleGreen_12.png", id:"LevelAssets_PurpleGreen_12", bundle:"LevelAssets"},
		{src:"assets/skins/images/LevelAssets/PurpleGreen_13.png", id:"LevelAssets_PurpleGreen_13", bundle:"LevelAssets"},
		{src:"assets/skins/images/LevelAssets/PurpleOrange_01.png", id:"LevelAssets_PurpleOrange_01", bundle:"LevelAssets"},
		{src:"assets/skins/images/LevelAssets/PurpleOrange_02.png", id:"LevelAssets_PurpleOrange_02", bundle:"LevelAssets"},
		{src:"assets/skins/images/LevelAssets/PurpleOrange_03.png", id:"LevelAssets_PurpleOrange_03", bundle:"LevelAssets"},
		{src:"assets/skins/images/LevelAssets/PurpleOrange_04.png", id:"LevelAssets_PurpleOrange_04", bundle:"LevelAssets"},
		{src:"assets/skins/images/LevelAssets/PurpleOrange_05.png", id:"LevelAssets_PurpleOrange_05", bundle:"LevelAssets"},
		{src:"assets/skins/images/LevelAssets/PurpleOrange_06.png", id:"LevelAssets_PurpleOrange_06", bundle:"LevelAssets"},
		{src:"assets/skins/images/LevelAssets/PurpleOrange_07.png", id:"LevelAssets_PurpleOrange_07", bundle:"LevelAssets"},
		{src:"assets/skins/images/LevelAssets/PurpleOrange_08.png", id:"LevelAssets_PurpleOrange_08", bundle:"LevelAssets"},
		{src:"assets/skins/images/LevelAssets/PurpleOrange_09.png", id:"LevelAssets_PurpleOrange_09", bundle:"LevelAssets"},
		{src:"assets/skins/images/LevelAssets/PurpleOrange_10.png", id:"LevelAssets_PurpleOrange_10", bundle:"LevelAssets"},
		{src:"assets/skins/images/LevelAssets/PurpleOrange_11.png", id:"LevelAssets_PurpleOrange_11", bundle:"LevelAssets"},
		{src:"assets/skins/images/LevelAssets/PurpleOrange_12.png", id:"LevelAssets_PurpleOrange_12", bundle:"LevelAssets"},
		{src:"assets/skins/images/LevelAssets/PurpleOrange_13.png", id:"LevelAssets_PurpleOrange_13", bundle:"LevelAssets"},
		{src:"assets/skins/images/LevelAssets/Tree_01.png", id:"LevelAssets_Tree_01", bundle:"LevelAssets"},
		{src:"assets/skins/images/LevelAssets/Tree_02.png", id:"LevelAssets_Tree_02", bundle:"LevelAssets"}
	],
	preloads: []
};



})(lib.LevelAssets = {}, images, ss, createjs);
module.exports = lib.LevelAssets;